// The native theme owns slide changes and timing. Manual interaction stops automatic switching.
function initOctoberSlideshow(root = document) {
  const carousel = root.querySelector('.october-slideshow');
  if (!carousel || carousel.dataset.initialized || !carousel.player) return;
  carousel.dataset.initialized = 'true';
  const stop = () => carousel.player.stop();
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) stop();
  carousel.querySelector('carousel-navigation')?.addEventListener('click', stop);
  carousel.addEventListener('focusin', stop);
}
customElements.whenDefined('slideshow-carousel').then(() => initOctoberSlideshow());
document.addEventListener('shopify:section:load', (event) => initOctoberSlideshow(event.target));
